<template>
  <div v-if="model.id">
    <div class="card-body">
      <h4
        class="card-title card-collapse pointer"
        @click="collapseState = !collapseState"
      >
        New Product Information
        <span class="icon-collapse">
          <button class="btn-icon-collapse">
            <template>
              <i v-if="collapseState" class="dripicons-minus" />
              <i v-else class="dripicons-plus" />
            </template>
          </button>
        </span>
      </h4>
      <b-collapse v-model="collapseState">
        <div class="pt-3">
          <div class="row">
            <div class="col-12">
              <div class="border-top pb-4"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-row form-group">
                <label class="col-lg-4 col-xl-3 col-form-label">
                  เลขที่เอกสารอ้างอิง
                </label>
                <label class="col-lg-4 col-xl-3 col-form-label">
                  {{ model.reference_id }}
                </label>
              </div>
              <div class="form-row form-group">
                <label
                  class="col-lg-4 col-xl-3 col-form-label"
                  for="productGroup"
                >
                  เอกสารขออนุมัติ
                </label>
                <label
                  class="col-lg-4 col-xl-3 col-form-label"
                  for="productGroup"
                >
                  <router-link
                    tag="a"
                    href=""
                    :to="{
                      name: 'products_register_request',
                      params: { id: model.id },
                    }"
                    target="_blank"
                  >
                    {{ model.id }}
                    <i class="bx bx-link-external"></i>
                  </router-link>
                </label>
              </div>
              <div class="form-row form-group">
                <label
                  class="col-lg-4 col-xl-3 col-form-label"
                  for="productGroup"
                >
                  ผู้ขออนุมัติ
                </label>
                <label
                  v-if="model.requestor"
                  id="popover-requestor-target"
                  class="col-lg-4 col-xl-3 col-form-label text-primary"
                  for="productGroup"
                >
                  {{ model.requestor.user_name.en }}
                  <i
                    v-if="model.requestor.user_type === 'Operator'"
                    class="mdi mdi-account-tie"
                  ></i>
                  <i v-else class="bx bxs-business"></i>
                </label>
                <UserInfoPopover
                  v-if="model.requestor"
                  :title_prefix="`${model.requestor.team_display_name}`"
                  v-model="model.requestor"
                  target_id="popover-requestor-target"
                  :is_display_name="false"
                />
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import UserInfoPopover from '@/components/share/user-info-popover'
import requestService from '@/helpers/service/request-document-service'
export default {
  components: {
    UserInfoPopover,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      model: {},
      collapseState: true,
    }
  },
  created() {
    console.log(this.id)
    this.getRequestDocumentDetailByRefIdAsync()
  },
  methods: {
    async getRequestDocumentDetailByRefIdAsync() {
      if (!this.id) return
      //Get Request Document by RI
      let requestDocument = await requestService.getRequestDocumentDetailByRefIdAsync(
        this.id
      )
      if (requestDocument.status === 200) {
        const dataDocument = requestDocument.data
        this.model = dataDocument
      }
      //  console.log(requestDocument)
    },
  },
}
</script>

<style scoped></style>
